import { render, staticRenderFns } from "./subscription-payment-follow-up.vue?vue&type=template&id=537a0f48&"
import script from "./subscription-payment-follow-up.vue?vue&type=script&lang=ts&"
export * from "./subscription-payment-follow-up.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports